<template>
  <div class="py-12 lg:py-20">
    <ul class="hidden lg:flex text-xl mx-auto w-full border-b">
      <li
        class="tab-head rounded-t-lg"
        :class="{'bg-smoke-100': active === 1}"
        @click="active = 1"
      >
        <img src="@/assets/icons/list.svg">
        <span class="pl-4">Description & Pricing</span>
      </li>
      <li
        class="tab-head rounded-t-lg"
        :class="{'bg-smoke-100': active === 2}"
        @click="active = 2"
      >
        <img src="@/assets/icons/specification.svg">
        <span class="pl-4">Specifications</span>
      </li>
      <li
        class="tab-head rounded-t-lg"
        :class="{'bg-smoke-100': active === 3}"
        @click="active = 3"
      >
        <img src="@/assets/icons/packaging.svg">
        <span class="pl-4">Packaging</span>
      </li>
      <li></li>
    </ul>
    <div
      class="flex lg:hidden tab-head-mobile"
      :class="{'bg-smoke-100 border-b-2 ': active === 1}"
      @click="toggle(1)"
      ref="tabHead"
    >
      <img src="@/assets/icons/list.svg">
      <span class="pl-4">Description & Pricing</span>
    </div>
    <div v-if="active === 1">
      <div
        class="opacity-75 text-sm py-8 list-styles-revert"
        v-html="product.description"
      />
      <ProductPricing
        key="product-pricing"
        :pricing="product.pricing"
      />
    </div>
    <div
      class="flex lg:hidden tab-head-mobile"
      :class="{'bg-smoke-100 border-b-2 ': active === 2}"
      @click="toggle(2)"
    >
      <img src="@/assets/icons/specification.svg">
      <span class="pl-4">Specifications</span>
    </div>
    <ProductSpecification
      v-if="active === 2"
      :product="product"
    />
    <div
      class="flex lg:hidden tab-head-mobile border-b-2"
      :class="{'bg-smoke-100': active === 3}"
      @click="toggle(3)"
    >
      <img src="@/assets/icons/packaging.svg">
        <span class="pl-4">Packaging</span>
    </div>
    <ProductPackaging
      v-if="active === 3"
      :packaging="product.packaging"
    />
  </div>
</template>
<script>
import ProductSpecification from './ProductSpecification'
import ProductPricing from './ProductPricing'
import ProductPackaging from './ProductPackaging'

export default {
  name: 'ProductDetails',
  components: {
    ProductSpecification,
    ProductPricing,
    ProductPackaging
  },
  props: {
    product: {
      required: true
    }
  },
  data() {
    return {
      active: 0
    }
  },
  mounted() {
    const val = window.getComputedStyle(this.$refs.tabHead).display === "none"
    this.active = val ? 1 : 0
  },
  methods: {
    toggle(val) {
      this.active = val === this.active ? 0 : val
    }
  }
}
</script>
<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-enter {
  top: 0%;
  transform: translateX(30%);
}
.tab-head {
  @apply h-12 px-8 py-2 cursor-pointer flex items-center;
}
.tab-head-mobile {
  @apply h-12 px-8 py-2 cursor-pointer items-center border-t-2;
}
/deep/.list-styles-revert {
  ol, ul {
    list-style: revert;
    margin: revert;
    padding: revert;
  }
}
</style>
